import { DEFAULT_PAGE_WIDTH, Text } from "@towersystems/roam-common-native";
import React from "react";
import { TabBar as BaseTopBar, TabBarProps } from "react-native-tab-view";
import { Colors, Spacings, View } from "react-native-ui-lib";

const TAB_HEIGHT = 75;

export const renderTabBar = ({ options, layout, ...props }: any) => {
  return (
    <View
      style={{
        maxWidth: layout.width,
        margin: "auto",
        overflow: "hidden",
        width: "100%",
        position: "relative",
      }}
    >
      <BaseTopBar
        {...props}
        layout={layout}
        indicatorStyle={{
          backgroundColor: Colors.black,
          height: 3,
          bottom: 0,
          //maxWidth: DEFAULT_PAGE_WIDTH,
        }}
        indicatorContainerStyle={{
          height: 3,
          inset: "auto auto -3px auto ",
          backgroundColor: Colors.borderColor,
          opacity: 0.6,
          bottom: 0,
          top: "auto",
        }}
        style={{
          boxShadow: "none",
          height: TAB_HEIGHT,
          backgroundColor: Colors.surface,
        }}
        contentContainerStyle={{
          height: TAB_HEIGHT,
          //  backgroundColor: Colors.surface,
        }}
        tabStyle={
          {
            // width: "100%",
            // backgroundColor: Colors.surface,
          }
        }
        options={Object.entries(options).reduce((acc, [key, value]) => {
          acc[key] = {
            //@ts-ignore
            ...value,
            label: ({ route, labelText, focused, color }: any) => (
              <Text
                style={{
                  textTransform: "none",
                  fontFamily: 1 == 1 ? "Gilmer-Medium" : "Gilmer-Regular",
                  width: 200,
                  textAlign: "center",
                }}
                variant="heading3"
                fontWeight={focused ? "bold" : "regular"}
              >
                {labelText}
              </Text>
            ),
          };
          return acc;
        }, {} as any)}
      />
    </View>
  );
};
